import { Component, inject, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import moment from 'moment';
import { Subject, takeUntil } from 'rxjs';
import { AllMaterialsStoreData } from 'src/app/modules/core/store/materials.signal.store';
import { MatBottomSheet } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-hpv-past-vaccinations',
  templateUrl: './hpv-past-vaccinations.component.html',
  styleUrls: ['./hpv-past-vaccinations.component.scss'],
})
export class HpvPastVaccinationsComponent implements OnInit {
  @Input() parentForm: FormGroup;
  @Input() sessionDetails: object;
  @Input() benDetails: object;
  @Input() year: number | string;
  @Input() dob: string;
  hpvMinVaccinatedDate = new Date();
  hpvMaxVaccinatedDate = new Date();
  hpvMaterials: any;
  destroy$ = new Subject();
  readonly _bottomSheet = inject(MatBottomSheet);

  readonly allMaterialsStore = inject(AllMaterialsStoreData);
  constructor() {}

  ngOnInit() {
    this.allMaterialsStore.getMaterialsByCategory({
      material_category: 4,
      district_access_check: false,
    });
    console.log(
      'benDetails',
      this.benDetails,
      this.sessionDetails,
      this.year,
      this.dob
    );
    if (this.benDetails) {
      this.year = this.benDetails['year'];
      this.dob = this.benDetails['dob'];
    }
    this.setHpvVaccinatedControl();
    this.setHpvMaterialControl();
  }

  setHpvVaccinatedControl() {
    const vaccinatedDateFormControl = this.parentForm.get(
      'hpv_vaccination_date'
    );
    const materialIdFormControl = this.parentForm.get('hpv_material_id');
    const otherMaterialFormControl = this.parentForm.get('hpv_material_other');
    const hpvAtPublicFormControl = this.parentForm.get(
      'hpv_vaccinated_at_public'
    );
    this.parentForm
      .get('is_hpv_vaccinated')
      .valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        vaccinatedDateFormControl.setValue(null);
        vaccinatedDateFormControl.setValidators(
          data ? Validators.required : []
        );
        vaccinatedDateFormControl.updateValueAndValidity();

        materialIdFormControl.setValue(null);
        otherMaterialFormControl.setValue(null);
        materialIdFormControl.setValidators(data ? Validators.required : []);
        materialIdFormControl.updateValueAndValidity();

        hpvAtPublicFormControl.setValue(null);
        hpvAtPublicFormControl.setValidators(data ? Validators.required : []);
        hpvAtPublicFormControl.updateValueAndValidity();
      });
  }
  setHpvMaterialControl() {
    const otherMaterialFormControl = this.parentForm.get('hpv_material_other');
    this.parentForm
      .get('hpv_material_id')
      .valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        otherMaterialFormControl.setValue(null);
        otherMaterialFormControl.setValidators(
          data === 'other' ? Validators.required : []
        );
        otherMaterialFormControl.updateValueAndValidity();
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['year'] || changes['dob']) {
      this.isHPVVaccinated();
    }
  }
  isHPVVaccinated() {
    this.hpvMinVaccinatedDate = moment(`${this.year}-01-01`)
      .add(14, 'years')
      .toDate();
    this.hpvMaxVaccinatedDate = moment(`${this.year}-01-01`)
      .add(15, 'years')
      .add(90, 'days')
      .toDate();

    if (this.dob) {
      this.hpvMinVaccinatedDate = moment(this.dob).add(14, 'years').toDate();
      this.hpvMaxVaccinatedDate = moment(this.dob)
        .add(15, 'years')
        .add(90, 'days')
        .startOf('day')
        .toDate();
    }
    const currentDate = new Date();
    if (currentDate < this.hpvMinVaccinatedDate) {
      this.hpvMinVaccinatedDate = moment().endOf('day').toDate();
    }
    if (currentDate < this.hpvMaxVaccinatedDate) {
      this.hpvMaxVaccinatedDate = moment()
        .subtract('1', 'day')
        .endOf('day')
        .toDate();
    }
  }
}
